/* eslint-disable max-len */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import GoogleLogin from 'react-google-login';
import { browserHistory } from 'react-router';

import config from '../../config';
import * as Constants from '../../constants';

import './LoginPage.scss';

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorText: '',
      isProcessing: false,
    };
    this.isCSCUser = window.sessionStorage.getItem('isCSCUser') === 'true';
  }

  componentDidMount = () => {
    if (this.props.user.isLoggedIn) {
      browserHistory.push('/customer-info');
    } else if (window.location.search.includes('isFromCSC')) {
      this.handleCSCLogin();
    }
  };

  onSignInSuccess = ({ tokenId } = {}) => {
    if (!tokenId) {
      this.setState({
        errorText: 'Login failed!!',
        isProcessing: false,
      });
      return;
    }
    this.props.actions.loginAgent(tokenId).then(res => {
      if (!res.status) {
        this.setState({
          errorText: (res.error && res.error.message) || 'Login failed!!',
          isProcessing: false,
        });
        return;
      }
      this.setState({
        errorText: '',
        isProcessing: false,
      });
    });
  };

  handleCSCLogin = () => {
    const url = window.encodeURIComponent(config.csc_client_callback_url);
    window.location.href = `${config.csc_connect_server_uri}/account/authorize?response_type=code&client_id=${config.csc_client_id}&redirect_uri=${url}&state=123`;
  };

  render() {
    const { errorText, isProcessing } = this.state;

    console.log('new branch ++++++++');

    return (
      <div className="loginContainer">
        <div className="title">
          <img className="icon" src={require('../../images/pe_logo.png')} />
          {!this.isCSCUser && <div className="text">Order On Call</div>}
        </div>
        <div className="loaderContainer">
          {isProcessing && <div className="loaderIcon spin" />}
        </div>
        {!this.isCSCUser ? (
          <GoogleLogin
            clientId={process.env.GLOGIN_CLIENT_ID}
            onSuccess={this.onSignInSuccess}
            onFailure={() =>
              this.setState({ errorText: '', isProcessing: false })
            }
            uxMode="popup"
            className="gLoginBtn"
            onRequest={() =>
              this.setState({ errorText: '', isProcessing: true })
            }
          >
            Login via Google
          </GoogleLogin>
        ) : (
          <button className="commonBtn cscLogin" onClick={this.handleCSCLogin}>
            Login via&nbsp;<strong>CSC</strong>
          </button>
        )}

        <div className="errorText">{errorText}</div>
      </div>
    );
  }
}
export default connect(
  state => ({
    user: state.user,
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  })
)(LoginPage);
